import { render } from "./schoolSafePolicy.vue?vue&type=template&id=ae34397a&scoped=true"
import script from "./schoolSafePolicy.vue?vue&type=script&lang=js"
export * from "./schoolSafePolicy.vue?vue&type=script&lang=js"

import "./schoolSafePolicy.vue?vue&type=style&index=0&id=ae34397a&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae34397a"]])

export default __exports__